import Feedbacks from './Feedbacks';

export default Feedbacks;
